<template>
<div>
<v-text-field
    :label="label"
    v-on:blur="onBlur"
    v-on:focus="onFocus"
    :value="internal_value"
    v-on:input="onInput"
    autocomplete="off"
    :persistent-hint="persistentHint"
    :hint="hint"
>
    
    <v-icon
        v-if="internal_show_validation_result && is_valid"
        color="green"
        slot="append-outer"
        style="margin-top: 5px"
    >
        mdi-check-bold
    </v-icon> 

    
    <v-icon
        v-if="internal_show_validation_result && !is_valid"
        color="red"
        slot="append-outer"
        style="margin-top: 5px"
        v-on:click="onClickAlert"
    >
        mdi-alert
    </v-icon> 
   
</v-text-field>
</div>
</template>

<script>
const Validate = require('@/js/validate.js');
export default {
    props: {
        label: {
            type: String,
            default: function() { return 'Label'; }
        },

        value: {
            type: String,
            default: function() { return null; }
        },

        show_validation_result: {
            type: Boolean,
            default: function() { return false; }
        },

        required: {
            type: Boolean,
            default: function() { return false; }
        },

        email: {
            type: Boolean,
            default: function() { return false; }
        },

        phone: {
            type: Boolean,
            default: function() { return false; }
        },

        us_or_ca_tax_id: {
            type: Boolean,
            default: function() { return false; }
        },

        url: {
            type: Boolean,
            default: function() { return false; },
        },

        'persistent-hint': {
            type: Boolean,
            default: function() { return false; }
        },

        hint: {
            type: String,
            default: function() { return null; }
        },

        
    },

    data() {
        return {
            internal_value: null,

            is_valid: true,
            invalid_reason: null,

            internal_show_validation_result: false, 

            has_focus: false,
            ever_had_focus: false,
        }
    },

    mounted () {
        this.internal_value = this.value;
        this.revalidate();
    },
   

    methods: {
        onClickAlert() {
            this.$rc.alert(this.label, this.invalid_reason);
        },

        onBlur()
        {
            this.has_focus = false;

            this.revalidate();
        },

        onFocus()
        {
            this.ever_had_focus = true;
            this.has_focus = true;

            this.revalidate();
        },

        onInput(value)
        {
            this.internal_value = value;
            this.revalidate();
            this.$emit('input', this.internal_value);
        },

        revalidate()
        {
            let compute_valid_result = this.computeIsValid();

            if ( compute_valid_result == true )
            {
                this.is_valid = true;
                this.invalid_reason = null;
            }
            else
            {
                this.is_valid = false;
                this.invalid_reason = compute_valid_result;
            }


            this.internal_show_validation_result = this.computeShowValidationResult();
        },

        computeIsValid()
        {
            let rules = [];

            if ( this.required )
                rules.push(this.ruleRequired);

            if ( this.email )
                rules.push(this.ruleOptionalEmailAddress);

            if ( this.phone )
                rules.push(this.ruleOptionalPhoneNumber);

            if ( this.us_or_ca_tax_id )
                rules.push(this.ruleOptionalTaxId);

            if ( this.url )
                rules.push(this.ruleOptionalUrl);

            for ( let i = 0; i < rules.length; i++ )
            {
                let cur_rule_result = rules[i](this.internal_value);

                if ( cur_rule_result == true )
                    continue;

                return cur_rule_result;
            }

            return true;
        },

        ruleRequired(value)
        {
            let test_value = value ?? '';
            test_value = test_value.trim();

            if ( test_value.length == 0 )
                return 'This field can not be blank &mdash; it is required';

            return true;
        },

        ruleOptionalEmailAddress(value)
        {
            let test_value = value ?? '';
            test_value = test_value.trim();

            if ( test_value.length == 0 ) 
                return true; 

            if ( !Validate.isEmailAddress(test_value) )
                return 'A valid email address is required';
            
            return true;
        },

        ruleOptionalTaxId(value)
        {
            let test_value = value ?? '';
            test_value = test_value.trim();

            if ( test_value.length == 0 ) 
                return true; 

            let numb = test_value.match(/\d/g);
            numb = numb.join("");

            if ( numb.length != 9 )
            {
                return 'Must be a valid tax identification number.  For US businesses, this is a SSN or EIN.  For CA businesses, use your BN9';
            }

            return true;
        },

        ruleOptionalPhoneNumber(value)
        {
            let test_value = value ?? '';
            test_value = test_value.trim();

            if ( test_value.length == 0 ) 
                return true; 

            if ( !Validate.isUSPhoneNumber(test_value) )
                return 'A valid phone number is required';
            
            return true;
        },

        ruleOptionalUrl(value)
        {
            let test_value = value ?? '';
            test_value = test_value.trim();

            if ( test_value.length == 0 ) 
                return true; 

            try 
            {
                new URL(test_value);
                return true;
            } 
            catch (err) 
            {
                return 'A valid url, e.g. https://www.google.com, is required.';
            }
        },

        computeShowValidationResult()
        {
            if ( this.has_focus )
                return false; // we don't show the validation result why typing...

            let test_value = this.internal_value ?? '';
            test_value = test_value.trim();

            if ( this.is_valid && test_value.length == 0 ) 
                return false; // Don't show a check mark on optional fields that are blank...

            if ( this.show_validation_result ) 
                return true; // the external "show validation result" flag has been tripped, so show it even if it has not been touched...

            if ( test_value.length > 0 )
                return true;
            
            if ( !this.ever_had_focus )
                return false; // we never had focus, show don't show the validation result...

            return true;
        },
    },

    watch: {
        show_validation_result(newValue, oldValue) {
            this.revalidate();
        },

        value(new_value, old_value)
        {
            this.internal_value  = new_value;
            this.revalidate();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>